module.exports = __webpack_public_path__ + "img/right-leg_hover.1f3c1cb4.png";